export const CORE_API_BASELINE = {
  version: '2.16.0',
  commit: 'aeeda3fc',
  apiPath: '/api/v0.1',
  registeredMethods: 90,
  notifications: 20,
} as const;
